import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Skeleton, Typography } from "antd";

import ApproveUserSubmission from "./ApproveUserSubmission";

const { Text } = Typography;

const ApproveTaskScreen = (props: any) => {
  const {
    task,
    users,
    loading,
    actions: { getTaskById, approveTaskSubmit },
  } = props;
  const id = useParams().id;
  const [showMoreDescription, setShowMoreDescription] = useState(false);
  const charMax = 225;

  useEffect(() => {
    id && getTaskById({ id });
  }, [id]);

  useEffect(() => {
    if (window.innerWidth < 1200) return;
    document.body.classList.add("assignment-grade-layout");

    return () => {
      document.body.classList.remove("assignment-grade-layout");
    };
  }, []);

  if (loading) return <Skeleton active />;

  return (
    <div>
      <div className="xl:flex pb-[60px]">
        <div className="xl:w-1/2 xl:pr-[70px] pb-[60px] xl:pb-0">
          <Card className="p-6 border-none shadow-sm">
            <div className="flex flex-col gap-6">
              <div>
                <Text className="text-neutral-600 text-sm font-semibold block">
                  Task Title
                </Text>
                <Text className="bg-neutral-100 rounded-lg mt-2 p-4 block text-neutral-600 text-base font-semibold">
                  {task?.title}
                </Text>
              </div>

              <div>
                <Text className="text-neutral-600 text-sm font-semibold block">
                  Description
                </Text>
                <div className="bg-neutral-100 rounded-lg mt-2 p-4">
                  <Text
                    className={`text-neutral-600 text-base block overflow-hidden ${
                      !showMoreDescription ? "max-h-[144px]" : "h-auto"
                    } `}
                  >
                    {!showMoreDescription
                      ? `${task?.description.substring(0, charMax)} ${
                          task?.description.length > charMax ? ".." : ""
                        } `
                      : task?.description}
                  </Text>
                  {task?.description.length > charMax && (
                    <Text
                      onClick={() => setShowMoreDescription((prev) => !prev)}
                      className="text-sm text-primary-600 font-semibold block mt-2 cursor-pointer w-fit"
                    >
                      {!showMoreDescription ? "More" : "Less"}
                    </Text>
                  )}
                </div>
              </div>

              {task?.coverImageKey && (
                <div>
                  <Text className="text-neutral-600 text-sm font-semibold block">
                    Cover Image
                  </Text>
                  <img
                    src={
                      task?.coverImageKey
                        ? `${process.env.REACT_APP_CLOUDFRONT_KEY}/${task?.coverImageKey}`
                        : ""
                    }
                    alt="cover"
                    className="rounded-lg w-full  mt-2 mb-6"
                  />
                </div>
              )}
            </div>
          </Card>
          {/*  */}
        </div>
        <div className="xl:w-1/2 xl:pl-[70px]">
          <ApproveUserSubmission
            users={users}
            approveTaskSubmit={approveTaskSubmit}
            loading={loading}
            taskId={task?.id}
          />
        </div>
      </div>
    </div>
  );
};

export default ApproveTaskScreen;
